<ion-header>
  <ion-item *ngIf="isGithub">
    <ion-label>GitHub Repo</ion-label>
    <ion-select
      interface="popover"
      class="select-outline"
      [(ngModel)]="githubProjectName"
      placeholder="Select a GitHub repo..."
      (ionChange)="loadExternalTasks()"
    >
      <ion-select-option
        *ngFor="let githubProject of githubProjects"
        [value]="githubProject.id"
        >{{ githubProject.name }}</ion-select-option
      >
    </ion-select>
  </ion-item>
  <ion-item *ngIf="isMonday">
    <ion-label>Monday.com Board</ion-label>
    <ion-select
      interface="popover"
      class="select-outline"
      [(ngModel)]="mondayBoardId"
      placeholder="Select a Monday.com board..."
      (ionChange)="loadExternalTasks()"
    >
      <ion-select-option
        *ngFor="let mondayBoard of mondayBoards"
        [value]="mondayBoard.id"
        >{{ mondayBoard.name }}</ion-select-option
      >
    </ion-select>
  </ion-item>
  <ion-item *ngIf="isAsana">
    <ion-label>Asana Project</ion-label>
    <ion-select
      interface="popover"
      class="select-outline"
      [(ngModel)]="asanaProjectId"
      placeholder="Select an Asana project..."
      (ionChange)="loadExternalTasks()"
    >
      <ion-select-option
        *ngFor="let asanaProject of asanaProjects"
        [value]="asanaProject.id"
        >{{ asanaProject.name }}</ion-select-option
      >
    </ion-select>
  </ion-item>
  <div class="flex-space-between flexed-align-center">
    <ion-searchbar
      *ngIf="supportsSearch"
      mode="ios"
      class="search-bar"
      [placeholder]="
        isGithub && !githubProjectName
          ? 'Select a GitHub repo..'
          : isMonday && !mondayBoardId
            ? 'Select a Monday.com board...'
            : 'Find ' + externalTaskManagementConfig.name + ' task...'
      "
      showCancelButton="never"
      [(ngModel)]="searchText"
      (ionChange)="handleFilters()"
      [disabled]="
        (isGithub && !githubProjectName) || (isMonday && !mondayBoardId)
      "
      #inputField
    ></ion-searchbar>
    <div
      class="top-searchbar flex-space-between"
      *ngIf="!supportsSearch"
      style="width: 100%; align-items: center; padding: 10px"
    >
      <ion-input
        fill="clear"
        class="search-bar"
        [(ngModel)]="selectedExternalTaskId"
        placeholder="Enter {{ externalTaskManagementConfig.name }} task ID..."
        (keyup.enter)="selectExternalTask(selectedExternalTaskId)"
        #inputField
      ></ion-input>
      <ion-button
        (click)="selectExternalTask(selectedExternalTaskId)"
        [disabled]="isLoading"
      >
        Submit
        <ion-spinner
          name="crescent"
          [hidden]="!isLoading"
          style="margin-left: 10px"
        ></ion-spinner>
        <ion-icon
          name="arrow-forward-outline"
          class="icon-padded-left button-icon"
          [hidden]="isLoading"
        ></ion-icon>
      </ion-button>
    </div>
  </div>
  <div
    *ngIf="supportsSearch"
    style="max-height: 50vh; min-height: 40px; overflow: auto"
  >
    <ion-list class="no-padding transparent-bg" *ngIf="!isLoading">
      <ion-item
        *ngFor="let externalTask of externalTasks"
        (click)="selectExternalTask(externalTask.id)"
        button="true"
      >
        {{ externalTask.friendlyId ? externalTask.friendlyId + " - " : ""
        }}{{ externalTask.name }}
      </ion-item>
      <ion-item
        *ngIf="
          isLoading === false &&
          !externalTasks?.length &&
          searchText &&
          searchText.length > 0
        "
        (click)="dismiss()"
      >
        None found.
      </ion-item>
      <ion-item
        *ngIf="isLoading === false && !externalTasks?.length && !searchText"
        (click)="dismiss()"
      >
        Begin typing to search.
      </ion-item>
    </ion-list>
    <div
      *ngIf="isLoading"
      style="
        display: flex;
        justify-content: center;
        align-items: center;
        opacity: 0.5;
        height: 100%;
      "
    >
      <ion-spinner name="crescent"></ion-spinner>
    </div>
  </div>
</ion-header>
